var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"modal-pdf-viewer",attrs:{"visible":_vm.visible,"before-close":_vm.close,"title":_vm.title,"width":"90%","top":"4vh","append-to-body":""}},[(_vm.visible && _vm.url)?_c('iframe',{staticClass:"pdf-frame",attrs:{"src":_vm.url,"title":_vm.title}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }